import decode from 'jwt-decode';
import axios from 'axios';

const headers = {
  'Authorization': localStorage.getItem('token') || '',
}

export default class AuthService {

  constructor(){
    this.api_url = 'https://login.healthfy.com.br/api';
    //this.api_url = 'http://localhost:8000/api';
    this.isAuthenticated = this.isAuthenticated.bind(this);
    this.login = this.login.bind(this);
    this.logout = this.logout.bind(this);
  }

  getToken(){
    return localStorage.getItem('token');
  }

  setToken(token, id) {
    localStorage.setItem('token', token);
    localStorage.setItem('id', id);
  }

  removeToken(){
    localStorage.removeItem('token');
    localStorage.removeItem('empresa');
    localStorage.removeItem('id');
  }

  isTokenExpired(token) {
    try {
      const decoded = decode(token);

      if (decoded.exp < Date.now() / 1000) return true;
      else return false;
    }
    catch (err) {
      return false;
    }
  }

  getEmpresa(){
    return localStorage.getItem('empresa');
  }

  setEmpresa(empresa){
    localStorage.setItem('empresa', empresa);
  }

  isAuthenticated() {
    const token = this.getToken();
    if (token != undefined && !this.isTokenExpired(token))
      return true
    else return false
  }

  login(email, password){
    axios.post(`${this.api_url}/login`, {
      email: email,
      password: password
    })
    .then(
      (res) => {
        let {token, tipo, empresa, id} = res.data
        if(token && tipo){
          this.setEmpresa(empresa); // Setting the empresa_id in localStorage
          this.setToken(token, id) // Setting the token and admin_id in localStorage
          return window.location.replace("/home");
        }else{
          alert('usuario ou senha errados')
        }
      },
      (err) => {
        console.log(err);
      }
    );
  }

  logout(){
    fetch(`${this.api_url}/logout`, {
      method: 'POST',
      headers: {
        ...headers,
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        token: this.getToken()
      })
    }).then(res => {
      this.removeToken() // Setting the token in localStorage
      return Promise.resolve(res);
    });
  }

  cadastraEmpresa(nome, cnpj, email, password, adminName){
    axios.post(`${this.api_url}/registrar-empresa`, {
      nome: nome,
      cnpj: cnpj
    })
    .then(
      (res) => {
        const resposta = res.data
        if(resposta.id){
          this.cadastraAdmin(resposta.id, email, password, adminName)
        }else if(resposta.nome){
          alert(resposta.nome)
        }else if(resposta.cnpj){
          alert(resposta.cnpj)
        }
      },
      (err) => {
        console.log(err);
      }
    );
  }

  cadastraAdmin(empresa_id, email, password, name){
    axios.post(`${this.api_url}/registrar-admin`, {
      name: name,
      email: email,
      password: password,
      empresa_id: empresa_id,
      tipo: 1
    })
    .then(
      (res) => {
        const resposta = res.data
        if(resposta[0]){
          alert(resposta[0])
        }else if(resposta.email){
          alert(resposta.email)
        }else if(resposta.password){
          alert(resposta.password)
        }else if(resposta.name){
          alert(resposta.name)
        }
      },
      (err) => {
        console.log(err);
      }
    );
  }

  getID(){
    return localStorage.getItem('id');
  }

  getPreferences(){
    let id = this.getID()
    return axios.get(`${this.api_url}/prefs/get/${id}`)
      .then((res) => {
        console.log(res)
        let resposta = JSON.parse(res.data.prefs)
        return resposta
      });
  }

  setPreferences(preferences){
    let id = this.getID()
    return axios.post(`${this.api_url}/prefs/set/${id}`, {preferences: JSON.stringify(preferences)});
  }


}



// WEBPACK FOOTER //
// ./src/services/AuthService.js